"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bold = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Bold = function Bold() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2 11.04C19.7153 10.1089 19.9902 9.06408 20 8V6.4C20 2.86538 17.1346 0 13.6 0H4.00002C3.11637 0 2.40002 0.716344 2.40002 1.6V22.4C2.40002 23.2837 3.11637 24 4.00002 24H15.2C18.7346 24 21.6 21.1346 21.6 17.6V16C21.5891 14.0693 20.7072 12.2467 19.2 11.04ZM13.6 4.8C14.4837 4.8 15.2 5.51634 15.2 6.4V8C15.2 8.88366 14.4837 9.6 13.6 9.6H7.20002V4.8H13.6ZM15.2 19.2C16.0837 19.2 16.8 18.4837 16.8 17.6V16C16.8 15.1163 16.0837 14.4 15.2 14.4H7.20002V19.2H15.2Z"
  }));
};

exports.Bold = Bold;